import { useId } from 'react'

const TestTube = ({
  fillLevel = 0,
  fillColor = '#7DD3FC',
  label = '',
  onClick,
  active = false,
  disabled = false,
  hasResult = false
}) => {
  const id = useId()

  return (
    <svg
      viewBox="0 0 40 100"
      width={35}
      height={90}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'default' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.2s ease'
      }}
    >
      <defs>
        {/* Glass gradient */}
        <linearGradient id={`tube-glass-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="rgba(200,220,240,0.6)" />
          <stop offset="20%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="50%" stopColor="rgba(200,220,240,0.3)" />
          <stop offset="80%" stopColor="rgba(255,255,255,0.4)" />
          <stop offset="100%" stopColor="rgba(200,220,240,0.5)" />
        </linearGradient>

        {/* Liquid gradient */}
        <linearGradient id={`tube-liquid-${id}`} x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor={fillColor} stopOpacity="0.85" />
          <stop offset="100%" stopColor={fillColor} stopOpacity="0.95" />
        </linearGradient>
      </defs>

      {/* Active/Result border */}
      {(active || hasResult) && (
        <rect
          x="5" y="2" width="30" height="85" rx="5"
          fill="none"
          stroke={hasResult ? 'var(--secondary)' : 'var(--primary)'}
          strokeWidth="2"
          style={active ? { animation: 'glow 1.5s ease-in-out infinite' } : {}}
        />
      )}

      {/* Test tube rim */}
      <ellipse
        cx="20" cy="8"
        rx="12" ry="4"
        fill="rgba(200,220,240,0.5)"
        stroke="#8BA8C4"
        strokeWidth="1.5"
      />

      {/* Test tube body */}
      <path
        d="M8 8 L8 70 Q8 82 20 82 Q32 82 32 70 L32 8"
        fill={`url(#tube-glass-${id})`}
        stroke="#8BA8C4"
        strokeWidth="1.5"
      />

      {/* Liquid fill */}
      {fillLevel > 0 && (
        <path
          d={`M10 ${80 - fillLevel * 0.65} L10 70 Q10 80 20 80 Q30 80 30 70 L30 ${80 - fillLevel * 0.65} Z`}
          fill={`url(#tube-liquid-${id})`}
        />
      )}

      {/* Glass shine */}
      <line
        x1="11" y1="15"
        x2="11" y2="65"
        stroke="rgba(255,255,255,0.5)"
        strokeWidth="2"
        strokeLinecap="round"
      />

      {/* Label */}
      <text
        x="20" y="96"
        fontSize="8"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="500"
      >
        {label}
      </text>
    </svg>
  )
}

export default TestTube
